import { EsigningProviderAuthenticationModeSlug, EsigningRecipientType } from 'shared/domains/apollo/generated/types';
export const getInitialValues = (recipient) => {
    if (!recipient) {
        return {
            email: '',
            firstName: '',
            lastName: '',
            type: EsigningRecipientType.Signatory,
            authenticationMode: EsigningProviderAuthenticationModeSlug.Email,
        };
    }
    const { type, email, authenticationMode, firstName, lastName, label, mobile, title } = recipient;
    return {
        type,
        email,
        authenticationMode,
        firstName,
        lastName,
        label,
        mobile,
        title,
    };
};
